import { isBefore, parseISO } from 'date-fns';
import { partition } from 'lodash-es';

/**
 * 尋找下一個要播放的排程貼文
 * 邏輯：
 * 1. 如果有過去的貼文且不是當前貼文，回傳最接近現在的過去貼文
 * 2. 否則回傳最接近現在的未來貼文
 *
 * @param currentPostId - 當前正在播放的貼文 ID
 * @param sortedScheduledPosts - 已排序的排程貼文列表
 */
export const findNextScheduledPost = (currentPostId: number | undefined | null, sortedScheduledPosts: any[]) => {
  if (!Array.isArray(sortedScheduledPosts) || !sortedScheduledPosts.length) {
    return null;
  }

  const now = Date.now();
  const [pastPosts, futurePosts] =
    partition(sortedScheduledPosts, (post) => isBefore(parseISO(post.scheduled_started_at), now));

  // the past post which is neasest to now
  const nearestPastPost = pastPosts[0];
  if (nearestPastPost && nearestPastPost.post_id !== currentPostId) {
    return nearestPastPost;
  }

  // the future post which is neasest to now
  const nearestFuturePost = futurePosts?.[futurePosts.length - 1];
  return nearestFuturePost ?? null;
};
